import React from 'react';
import PropTypes from 'prop-types';
import FormattedListValue from '@/shared/components/FormattedListValue';
import SimplePanel from '@/shared/components/SimplePanel';
import { injectIntl, FormattedMessage, FormattedDate } from 'react-intl';
import messages from '../jobMessages';
import FormattedCurrency from '../../../shared/components/FormattedCurrency';
import Checkbox from '@/shared/components/input/Checkbox';
import FormattedDateShort from '../../../shared/components/FormattedDateShort';

const JobDetailSetInvoiceSchedule = ({ job }) => {
  // Some json parameters might still be stored without camelcase in the db, so convert it to camelcase just in case
  const { parameters } = job;
  return (
    <SimplePanel title={<FormattedListValue list="jobType" id={job.jobType} />}>
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Schedule} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                {parameters.scheduleId ? (
                  <FormattedListValue
                    list="invoiceschedule"
                    id={parameters.scheduleId}
                    fallback=""
                  />
                ) : (
                  <FormattedMessage {...messages.NoSchedule} />
                )}
              </div>
            </div>
            {parameters.amount !== 0 && (
              <div className="row">
                <div className="col-md-5 col-sm-6">
                  <label>
                    <b>
                      <FormattedMessage {...messages.Amount} />
                    </b>
                  </label>
                </div>
                <div className="col-md-7 col-sm-6">
                  <FormattedCurrency value={parameters.amount} />
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.LedgerAccount} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">{parameters.ledgerAccount}</div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="row">
              <div className="col-md-8 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.StartPlanning} />
                  </b>
                </label>
              </div>
              <div className="col-md-4 col-sm-6">
                <FormattedDateShort value={parameters.startDate} />
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.EndPlanning} />
                  </b>
                </label>
              </div>
              <div className="col-md-4 col-sm-6">
                {parameters.endDate && <FormattedDateShort value={parameters.endDate} />}
              </div>
            </div>
            <div className="row">
              <div className="col-md-8 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.OverrideExistingSchedule} />
                  </b>
                </label>
              </div>
              <div className="col-md-4 col-sm-6">
                <Checkbox value={parameters.overrideExistingSchedule} onClick={() => {}} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </SimplePanel>
  );
};

JobDetailSetInvoiceSchedule.propTypes = {
  job: PropTypes.shape({}).isRequired,
};

export default injectIntl(JobDetailSetInvoiceSchedule);
